import moment from "moment";
export var formatReservationTimestamp = function(value) {
    if (!value) return "-";
    var timestamp = moment.utc(value);
    return timestamp.isValid() ? timestamp.format("DD/MM/YYYY HH:mm") : "-";
};
export var formatReservationDuration = function(startValue, endValue) {
    if (!startValue || !endValue) return "-";
    var start = moment.utc(startValue);
    var end = moment.utc(endValue);
    if (!start.isValid() || !end.isValid() || end.isBefore(start)) return "-";
    var totalMinutes = end.diff(start, "minutes");
    var days = Math.floor(totalMinutes / (24 * 60));
    var hours = Math.floor(totalMinutes % (24 * 60) / 60);
    var minutes = totalMinutes % 60;
    return "".concat(days, " D, ").concat(hours, " H, ").concat(minutes, " M");
};
export var isReservationDurationAtLeastOneDay = function(startValue, endValue) {
    if (!startValue || !endValue) return false;
    var start = moment.utc(startValue);
    var end = moment.utc(endValue);
    return start.isValid() && end.isValid() && !end.isBefore(start) && end.diff(start, "minutes") >= 24 * 60;
};
